import { format } from 'date-fns';

// Valores emitidos pelo DateFilter. Mesmo conjunto usado no Analytics.
export type DateFilterType =
  | 'Diário'
  | 'Semanal'
  | 'Mensal'
  | 'Anual'
  | 'Personalizado';

// [rótulo do período, data inicial, data final] — as datas em yyyy-MM-dd, que
// é o formato que o toDate do IFLEX entende.
export type FiltroData = [DateFilterType, string, string];

export function setaFiltroDiario(): FiltroData {
  const data = new Date();
  const dataHoje = format(data, 'yyyy-MM-dd');
  return ['Diário', dataHoje, dataHoje];
}

export function setaFiltroMensal(): FiltroData {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = hoje.getMonth();
  const ultimoDiaMes = new Date(ano, mes + 1, 0).getDate();
  return [
    'Mensal',
    format(new Date(ano, mes, 1), 'yyyy-MM-dd'),
    format(new Date(ano, mes, ultimoDiaMes), 'yyyy-MM-dd'),
  ];
}

// Padrão das telas financeiras do OktonBank. No diário ou no mensal a tela
// abriria quase sempre vazia: extrato e baixa raramente são do mês corrente,
// e tela vazia por causa do filtro é indistinguível de tela quebrada.
export function setaFiltroAnual(): FiltroData {
  const ano = new Date().getFullYear();
  return [
    'Anual',
    format(new Date(ano, 0, 1), 'yyyy-MM-dd'),
    format(new Date(ano, 11, 31), 'yyyy-MM-dd'),
  ];
}
